import { render, staticRenderFns } from "./ServiceDeleteApikeyDialog.vue?vue&type=template&id=2b0baefe&scoped=true"
import script from "./ServiceDeleteApikeyDialog.vue?vue&type=script&lang=js"
export * from "./ServiceDeleteApikeyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0baefe",
  null
  
)

export default component.exports